import moment from "moment-timezone";
import { ENUM_RESCHEDULE_REASON_TYPE } from "../../../../enums";
import { VendorSlot } from "../../vendor-slot-selection/types";
import { buildSuggestedTimeSlotsPayload } from "../utils";
import type { MeetingRescheduleReason } from "../../../../constants";

type ProjectRescheduleReasonFields = {
  rescheduleReasonType?: string;
  rescheduleReason?: string;
};

export const hasProjectRescheduleReason = ({
  rescheduleReasonType,
  rescheduleReason,
}: ProjectRescheduleReasonFields) =>
  Boolean(rescheduleReasonType || rescheduleReason?.trim());

export const validateAmbassadorSlots = (item: { slots: VendorSlot[] }) => {
  let isFormValid = true;
  let slotSelectionCount = 0;

  const isAllSlotsEmpty = item.slots.every(
    (itemslot) =>
      !itemslot.selectedSlotTimeFrom && !itemslot.selectedSlotTimeTo
  );

  if (isAllSlotsEmpty) {
    return {
      updatedList: item,
      isFormValid: false,
      formMessage: "Please select the times",
    };
  }

  item.slots.forEach((slotsItem, slotsIndex) => {
    const overLapIndex: number[] = [];

    if (slotsItem.selectedSlotTimeFrom && slotsItem.selectedSlotTimeTo) {
      slotSelectionCount++;
    }

    item.slots.forEach((slotsItemInner, slotsIndexInner) => {
      if (
        slotsIndexInner !== slotsIndex &&
        slotsItem.selectedSlotTimeFrom &&
        slotsItem.selectedSlotTimeTo &&
        slotsItemInner.selectedSlotTimeFrom &&
        slotsItemInner.selectedSlotTimeTo &&
        moment(slotsItem.selectedSlotTimeFrom).diff(
          moment(slotsItemInner.selectedSlotTimeFrom),
          "minutes"
        ) === 0 &&
        moment(slotsItem.selectedSlotTimeTo).diff(
          moment(slotsItemInner.selectedSlotTimeTo),
          "minutes"
        ) === 0
      ) {
        overLapIndex.push(slotsIndexInner + 1);
      }
    });

    if (overLapIndex.length > 0) {
      slotsItem.error = `Matching with slot ${overLapIndex.join(",")}`;
      isFormValid = false;
    } else if (
      (slotsItem.selectedSlotTimeTo && !slotsItem.selectedSlotTimeFrom) ||
      (!slotsItem.selectedSlotTimeTo && slotsItem.selectedSlotTimeFrom)
    ) {
      slotsItem.error = "From and To date are required";
      isFormValid = false;
    } else {
      slotsItem.error = "";
    }
  });

  const isSlotsValid = item.slots.every((slot) => !slot.error);

  if (slotSelectionCount < 3) {
    return {
      updatedList: item,
      isFormValid: false,
      formMessage: "Please select at least 3 alternative times",
    };
  }

  return {
    updatedList: item,
    isFormValid: isSlotsValid,
    formMessage: isSlotsValid ? "" : "Please check all the selected times",
  };
};

type BuildMeetingReschedulePayloadParams = {
  reason: MeetingRescheduleReason;
  otherReason?: string;
  slots: VendorSlot[];
  clientTimezoneValue?: string;
};

export const buildMeetingReschedulePayload = ({
  reason,
  otherReason = "",
  slots,
  clientTimezoneValue,
}: BuildMeetingReschedulePayloadParams) => {
  return {
    reasonType: reason,
    ...(reason === ENUM_RESCHEDULE_REASON_TYPE.OTHER && {
      reasonText: otherReason.trim(),
    }),
    suggestedTimeSlots: buildSuggestedTimeSlotsPayload(
      slots,
      clientTimezoneValue
    ),
  };
};
